import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { DivisionSummaryReportSchemaObject } from '../DivisionSummaryReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { isNumber } from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import moment from 'moment';
import { Chip, Grid, Typography } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';

const screenCode = "INTEGRATIONDETAILSREPORT";

export function IntegrationDetailsReport(props) {

    const componentRef = useRef();
    const [divisions, setDivisions] = useState([]);
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [reportData, setReportData] = useState([]);
    const [successCount, setSuccessCount] = useState(0);
    const [failedCount, setFailedCount] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [integrationDetails, setDivisionSummaryDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        currentID: "0",
        statusID: "0",
        transactionTypeID: "0",
        toDate: "",
        fromDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        estateID: "0",
        division: "0",
        transactionType: "0",
        toDate: "",
        fromDate: ""
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [csvHeaders, setCsvHeaders] = useState([
        { label: "Emp Reg No", value: "empNo" },
        { label: "Division", value: "collectionPointName" },
        { label: "Current", value: "isCurrent" },
        { label: "Transaction Type", value: "apiTypeName" },
        { label: "Date", value: "date" },
        { label: "Status", value: "status" },
        { label: "Created Date & Time", value: "createdDate" },
        { label: "Response Message", value: "responseMessage" },
    ]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const schema = Joi.object(DivisionSummaryReportSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(getEstatesForDropdown())
        clearState();
    }, [integrationDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionsForDropDown())
        clearState();
    }, [integrationDetails.estateID])

    useEffect(() => {
        setCount();
    }, [reportData]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINTEGRATIONDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setDivisionSummaryDetails({
            ...integrationDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(integrationDetails.groupID);
        setEstates(data);
    }
    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(integrationDetails.estateID);
        setDivisions(data);
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, integrationDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getIntegrationReportData(integrationDetails);

        setReportData(result);
        setCsvData(result);

        destroyDataTable();
        getSelectedDropdownValuesForReport(integrationDetails)
    }

    async function setCount() {
        let scount = reportData.filter(x => x.status == 'Success');
        setSuccessCount(scount.length);

        let fcount = reportData.filter(x => x.status == 'Failed');
        setFailedCount(fcount.length);
    }

    function handleChange(target) {
        validateInputs(target);

        setDivisionSummaryDetails({
            ...integrationDetails,
            [target.name]: target.value,
        });
        setReportData([]);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DivisionSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function createFile() {
        var settings = {
            sheetName: 'Integration Details Report',
            fileName: 'IntegrationDetailsReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            empNo: "Group :" + groups[integrationDetails.groupID],
            collectionPointName: "Estate : " + estates[integrationDetails.estateID],
            isCurrent: "To Date : " + integrationDetails.toDate,
            apiTypeName: "From Date : " + integrationDetails.fromDate,
        }
        var newRow2 = {
            empNo: "Transaction Type : " + integrationDetails.transactionTypeID == '0' ? "All" :
                integrationDetails.transactionTypeID == '1' ? "Checkroll " : integrationDetails.transactionTypeID == '2' ? "OverTime" :
                    integrationDetails.transactionTypeID == '3' ? "Outgrower " : "BoughtLeaf",
        }
        copyOfCsv.push({}, {}, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function destroyDataTable() {
        $('#example3').DataTable().destroy();
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setDivisionSummaryDetails({
            ...integrationDetails,
            divisionID: "0",
            currentID: "0",
            statusID: "0",
            transactionTypeID: "0",
            toDate: "",
            fromDate: ""
        });
        setErrors("");
        setReportData([]);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            transactionType: searchForm.transactionTypeID,
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate

        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Integration Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={integrationDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={integrationDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Transaction Type </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="transactionTypeID"
                                            id="transactionTypeID"
                                            name="transactionTypeID"
                                            value={integrationDetails.transactionTypeID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Transaction Type--</MenuItem>
                                            <MenuItem value="1">Checkroll</MenuItem>
                                            <MenuItem value="2">OverTime</MenuItem>
                                            <MenuItem value="3">Outgrower</MenuItem>
                                            <MenuItem value="4">BoughtLeaf</MenuItem>

                                        </Select>
                                        {errors["transactionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["transactionTypeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={integrationDetails.divisionID}
                                            disabled={integrationDetails.transactionTypeID === '4'}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Current *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="currentID"
                                            id="currentID"
                                            name="currentID"
                                            value={integrationDetails.currentID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Current--</MenuItem>
                                            <MenuItem value="1">Yes</MenuItem>
                                            <MenuItem value="2">No</MenuItem>
                                        </Select>
                                        {errors["currentID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["currentID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Status </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="statusID"
                                            id="statusID"
                                            name="statusID"
                                            value={integrationDetails.statusID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Status--</MenuItem>
                                            <MenuItem value="1">Success</MenuItem>
                                            <MenuItem value="2">Failed</MenuItem>
                                        </Select>
                                        {errors["statusID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["statusID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, integrationDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {reportData.length != 0 ?
                                <div >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <div className="form-group row">
                                                    <div className="col-md-1">
                                                        {successCount > 0 ?
                                                            <Grid >
                                                                <Typography color="textSecondary" gutterBottom>
                                                                    <Chip style={{ marginLeft: '1rem', backgroundColor: "#bad8ae", color: 'black', fontWeight: 'bold' }} alignContent="left"
                                                                        label={"Success count : " + successCount}
                                                                        clickable
                                                                    />
                                                                </Typography>
                                                            </Grid> : null}
                                                    </div>
                                                    <div className="col-md-1">
                                                        {failedCount > 0 ?
                                                            <Grid >
                                                                <Typography color="textSecondary" gutterBottom>
                                                                    <Chip style={{ marginLeft: '5rem', backgroundColor: "#ebb8b1", color: 'black', fontWeight: 'bold' }} alignContent="left"
                                                                        label={"Failed count : " + failedCount}
                                                                        clickable
                                                                    />
                                                                </Typography>
                                                            </Grid> : null}
                                                    </div>
                                                </div>
                                                <Box display="flex" justifyContent="flex-end" flexDirection="column" >
                                                    <TableContainer component={Paper} style={{ maxHeight: '500px', overflow: 'auto' }}>
                                                        <Table able size="small" aria-label="sticky table" Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                                                        Emp Reg No
                                                                    </TableCell>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                                                        Division
                                                                    </TableCell>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                                                        Current
                                                                    </TableCell>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                                                        Transaction Type
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Date
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Status
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Created Date and Time
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Response Message
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody >
                                                                {reportData.slice(page * limit, page * limit + limit).map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.empNo == undefined ? '-' : row.empNo}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.collectionPointName == undefined ? '-' : row.collectionPointName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.isCurrent == true ? 'Yes' : 'No'}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.apiTypeName == undefined ? '-' : row.apiTypeName}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {moment(row.date).format("YYYY-MM-DD")}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="center" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.status == 'Success' ?
                                                                                <Chip style={{ marginLeft: '1rem', backgroundColor: "#bad8ae", color: 'black', }} alignContent="left"
                                                                                    label={row.status}
                                                                                    clickable
                                                                                /> :
                                                                                <Chip style={{ marginLeft: '1rem', backgroundColor: "#ebb8b1", color: 'black', }} alignContent="left"
                                                                                    label={row.status}
                                                                                    clickable
                                                                                />}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {moment(row.createdDate).format("YYYY-MM-DD HH:mm")}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.responseMessage == undefined ? '-' : row.responseMessage}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                            <TablePagination
                                                component="div"
                                                count={reportData.length}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handleLimitChange}
                                                page={page}
                                                rowsPerPage={limit}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        {reportData.length != 0 ?
                            <div className="pt-2">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"

                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf
                                        ref={componentRef}
                                        reportData={reportData}
                                        searchData={selectedSearchValues}
                                    />
                                </div> *
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
